import { createContext, useContext, useEffect, useState } from "react";
import { dict } from "@/i18n";

const LanguageContext = createContext(null);

export const useLang = () => useContext(LanguageContext);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("itminane-lang") || "en");

  useEffect(() => {
    const root = document.documentElement;
    root.lang = lang;
    root.dir = lang === "ar" ? "rtl" : "ltr";
    document.body.classList.toggle("font-arabic", lang === "ar");
    localStorage.setItem("itminane-lang", lang);
  }, [lang]);

  const value = {
    lang,
    isAr: lang === "ar",
    toggle: () => setLang((l) => (l === "en" ? "ar" : "en")),
    t: dict[lang],
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}
